import Base from "./Base";
import axios from "./axios_c";
import Profile from "@system/config/profile";
import ResponseMaker from "./ProfileAPICall/responseMaker";
import { __remove, __set } from "../store/axios_indicator";
import Helper from "src/support/Helper";

class ProfileAPICall extends Base {
    getProfileAccountInformation = async (params = {}) => {
        let res = {};
        // if (liveAuth.permit('VIEW_FORECAST').status) {
        await this.axiosCall(Profile.PROFILE_ACCOUNT_INFORMATION, {
            ...params
        }, 'GET').then((resHer) => {
            res = resHer.data.data;
        });
        // }
        if (res) {
            let result = await new ResponseMaker(res)
            result = await result.process(params)
            return result.run().get()
        } else {
            return res
        }

    };

    axiosCall = async (url, data = {}, method = 'post', skipParams = false, isBlob = false) => {
        if (data === 'NA') {
            data = {};
        } else {
            data = await this.mergeDataWithBase(data);
        }
        let config = {
            method: method,
            url: url,
            /* headers: {
                'accept': 'text/plain',
                'Content-Type': 'application/json-patch+json'
            }, */
            headers: Helper.getCommonHeader(method),
            data: data
        };

        // Set Response Type as Blob 
        if (isBlob) {
            config.responseType = 'blob';
        }

        if (skipParams === false && (config.method !== 'post' && config.method !== 'POST')) {
            config.params = data;
        }
        return axios(config);
    };
    mergeDataWithBase = async (data) => {
        return {
            ...data
        };
    };


}

export default ProfileAPICall;